interface RadiusProps {
  topLeftRadius: number;
  topRightRadius: number;
  bottomLeftRadius: number;
  bottomRightRadius: number;
}

interface GetRectanglePathProps extends RadiusProps {
  x: number;
  y: number;
  width: number;
  height: number;
  animateFromY?: number | undefined;
}

export const getRectanglePath = ({
  x,
  y,
  width,
  height,
  topLeftRadius,
  topRightRadius,
  bottomLeftRadius,
  bottomRightRadius,
}: GetRectanglePathProps) => {
  return `
    M${x + topLeftRadius},${y} 
    h${width - topRightRadius - topLeftRadius} 
    q${topRightRadius}, 0, ${topRightRadius}, ${topRightRadius} 
    v${height - bottomRightRadius - topRightRadius} 
    q0, ${bottomRightRadius}, ${-bottomRightRadius} ${bottomRightRadius}  
    h${-(width - bottomRightRadius - bottomLeftRadius)}
    q${-bottomLeftRadius}, 0, ${-bottomLeftRadius}, ${-bottomLeftRadius}
    v${-(height - bottomLeftRadius - topLeftRadius)}
    q0, ${-topLeftRadius}, ${topLeftRadius} ${-topLeftRadius} 
    Z`;
};

export const getMinPossibleHeight = ({
  topLeftRadius,
  topRightRadius,
  bottomLeftRadius,
  bottomRightRadius,
}: RadiusProps) => {
  const totalVerticalRadiusLeft = topLeftRadius + bottomLeftRadius;
  const totalVerticalRadiusRight = topRightRadius + bottomRightRadius;
  const maxTotalVerticalRadius = Math.max(
    totalVerticalRadiusLeft,
    totalVerticalRadiusRight,
  );

  return maxTotalVerticalRadius;
};

export const getStartingAnimationPath = ({
  x,
  y,
  width,
  height,
  topLeftRadius,
  topRightRadius,
  bottomLeftRadius,
  bottomRightRadius,
  animateFromY,
}: GetRectanglePathProps) => {
  if (animateFromY) {
    return getRectanglePath({
      x,
      y: animateFromY,
      width,
      height,
      topLeftRadius,
      topRightRadius,
      bottomLeftRadius,
      bottomRightRadius,
    });
  }

  // animate from lowest possible height
  const minPossibleHeight = getMinPossibleHeight({
    topLeftRadius,
    topRightRadius,
    bottomLeftRadius,
    bottomRightRadius,
  });
  const initialY = y + height - minPossibleHeight;

  return getRectanglePath({
    x,
    y: initialY,
    width,
    height: minPossibleHeight,
    topLeftRadius,
    topRightRadius,
    bottomLeftRadius,
    bottomRightRadius,
  });
};
